define('home/views/NotificationCardAnnouncementView',[
    'home/views/common/ActivityCardView',
    'home/mixins/withReason',
    'home/mixins/asNotificationCard',

    'home/templates/notificationCardAnnouncement',
], function (
    ActivityCardView,
    withReason,
    asNotificationCard,

    notificationCardAnnouncementTemplate
) {
    'use strict';

    var parent = ActivityCardView;

    /**
     * A notification card showing a custom announcement.
     *
     * Expects an ActivityFeedItem model with at least 1 AnnouncementActivity
     * rolled up.
     */
    var NotificationCardAnnouncementView = parent.extend({
        template: notificationCardAnnouncementTemplate,
        templateHelpers: function () {
            var announcement = this.getAnnouncement();
            var linkArgDelimiter = announcement.get('link') && announcement.get('link').indexOf('?') > 0 ? '&' : '?';

            return {
                announcement: announcement.toJSON(),
                linkArgDelimiter: linkArgDelimiter,
                activityId: this.model.activities[0].get('backendId'),
            };
        },

        className: 'card-notif-announcement',

        getAnnouncement: function () {
            return this.model.activities[0].object;
        },

        // By defining this, the asNotificationCard mixin will add in the view/click
        // tracking calls.
        getAnalyticsPayload: function (verb) {
            var announcement = this.getAnnouncement();
            return {
                verb: verb,
                object_type: 'note',
                object_id: this.model.activities[0].get('backendId'),
                note_template_id: announcement.get('templateId'),
                note_template_name: announcement.get('templateName'),
            };
        },
    });

    withReason.call(NotificationCardAnnouncementView.prototype);
    asNotificationCard.call(NotificationCardAnnouncementView.prototype);

    return NotificationCardAnnouncementView;
});

